import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
  const navigate = useNavigate();

  // Pasos: 1 = pedir identificador, 2 = ingresar código + nueva password
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState('');
  const [channel, setChannel] = useState('');
  const [target, setTarget] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  async function requestCode(e) {
    e.preventDefault();
    setError(''); setSuccess(''); setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: identifier.trim() }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'No se pudo procesar la solicitud');
        return;
      }
      setChannel(data.channel);
      setTarget(data.target || '');
      setSuccess(data.message || 'Código enviado');
      setStep(2);
    } catch {
      setError('Error de conexión. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  }

  async function resetPassword(e) {
    e.preventDefault();
    setError(''); setSuccess('');
    if (code.length !== 6) return setError('El código debe tener 6 dígitos');
    if (newPassword.length < 6) return setError('La contraseña debe tener al menos 6 caracteres');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          identifier: identifier.trim(),
          code,
          new_password: newPassword,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Código incorrecto');
        return;
      }
      setSuccess('¡Contraseña actualizada! Redirigiendo al login…');
      setTimeout(() => navigate('/login?modo=cliente', { replace: true }), 1500);
    } catch {
      setError('Error de conexión. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-layout">
      <form onSubmit={step === 1 ? requestCode : resetPassword} className="auth-card">
        <div className="auth-brand">
          <img src="/logo.png" alt="Autonation" className="auth-logo auth-logo-xl" onError={e => { e.target.style.display = 'none'; }} />
          <div className="auth-brand-sub">
            {step === 1 ? 'Recuperar contraseña' : 'Verificar código'}
          </div>
        </div>

        {step === 1 ? (
          <>
            <p style={{ color: 'var(--silver-light,#cbd5e1)', textAlign: 'center', margin: '0 0 1.5rem', fontSize: '0.95rem' }}>
              Ingresá tu email o número de teléfono.<br />
              Te enviaremos un código de 6 dígitos para restablecer tu contraseña.
            </p>

            <div className="form-group">
              <label className="form-label">Email o teléfono</label>
              <input
                className="form-input"
                type="text"
                placeholder="tu@email.com  o  +593 99 999 9999"
                value={identifier}
                onChange={e => setIdentifier(e.target.value)}
                required
                autoFocus
              />
            </div>

            {error && <div className="error-text">{error}</div>}

            <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: '1rem' }}>
              {loading ? 'Enviando…' : 'Enviar código →'}
            </button>
          </>
        ) : (
          <>
            <p style={{ color: 'var(--silver-light,#cbd5e1)', textAlign: 'center', margin: '0 0 1.5rem', fontSize: '0.95rem' }}>
              Enviamos un código por <strong style={{ color: '#fff' }}>{channel === 'email' ? 'email' : 'SMS'}</strong> a:<br />
              <strong style={{ color: '#fff' }}>{target}</strong>
            </p>

            <div className="form-group">
              <label className="form-label">Código de 6 dígitos</label>
              <input
                className="form-input"
                placeholder="000000"
                maxLength={6}
                inputMode="numeric"
                pattern="[0-9]{6}"
                value={code}
                onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                autoFocus
                required
                style={{ letterSpacing: '0.3em', fontSize: '1.4rem', textAlign: 'center' }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Nueva contraseña</label>
              <div style={{ position: 'relative' }}>
                <input
                  className="form-input"
                  type={showPwd ? 'text' : 'password'}
                  placeholder="Mínimo 6 caracteres"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  required
                  minLength={6}
                  style={{ paddingRight: '60px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPwd(s => !s)}
                  style={{
                    position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                    background: 'transparent', border: 'none', color: 'var(--silver-dark)',
                    fontSize: '0.85rem', cursor: 'pointer',
                  }}
                >
                  {showPwd ? 'Ocultar' : 'Ver'}
                </button>
              </div>
            </div>

            {error && <div className="error-text">{error}</div>}
            {success && <div style={{ color: '#4ade80', fontSize: '0.9rem', textAlign: 'center', marginTop: '0.5rem' }}>{success}</div>}

            <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: '1rem' }}>
              {loading ? 'Actualizando…' : 'Cambiar contraseña →'}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => { setStep(1); setCode(''); setNewPassword(''); setError(''); setSuccess(''); }}
              disabled={loading}
              style={{ marginTop: '0.5rem' }}
            >
              ← Volver
            </button>
          </>
        )}

        <div className="hint-text" style={{ marginTop: '1.2rem', textAlign: 'center' }}>
          <Link to="/login?modo=cliente" className="link">Volver al login</Link>
        </div>
      </form>
    </div>
  );
}
